import React from 'react';
import {BsArrowUpShort} from 'react-icons/bs'
const stats = [
    { name: 'Total Forms Submitted', stat: '71,897' },
    { name: 'Last 7 days', stat: '58' },
    { name: 'Incomplete Forms', stat: '24' },
  ]
  
   const ActivityStat = () => {
    return (
      <div className="mb-6">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Activity Statistics</h3>
          <p className="text-sm text-gray-600 mt-1">Overview of form submission activity</p>
        </div>
        <dl className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((item) => (
            <div key={item.name} className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 hover:shadow-md transition-shadow">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <dt className="text-sm font-medium text-gray-600 truncate">{item.name}</dt>
                  <dd className="mt-2 text-2xl sm:text-3xl font-bold text-gray-900">{item.stat}</dd>
                </div>
                <div className='flex items-center space-x-1 px-2 py-1 rounded-full bg-green-50 text-green-700 text-xs font-medium'>
                  <BsArrowUpShort className="h-4 w-4"/>
                  <span>20%</span>
                </div>
              </div>
            </div>
          ))}
        </dl>
      </div>
    )
  }
  
  export default ActivityStat